<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Quản lý trạng thái sử dụng thiết bị</h1>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="">
          <div class="form-group">
            <input
              v-model.trim="filters.fullTextSearch"
              type="text"
              placeholder="Tên/mã/địa chỉ thiết bị"
              style="border-radius: 4px"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="filters.moId"
              :options="moOptions"
              :settings="moSettings"
              placeholder="Tìm kiểm merchant owner"
              @change="onChangeMo"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.maId"
              :options="maOptions"
              :settings="maSettings"
              placeholder="Tìm kiếm merchant account"
              @change="onChangeMa"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.storeId"
              :options="storeOptions"
              :settings="storeSettings"
              placeholder="Tìm kiếm cửa hàng"
            />
          </div>

          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate('DD/MM/YYYY') }} -
                  {{ picker.endDate | formatDate('DD/MM/YYYY') }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian xuất lần đầu
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.regionCode"
              :options="dataConfigRegionMC"
              @change="queryMcProvince($event)"
              placeholder="Vùng cửa hàng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.provinceCode"
              :options="dataProvinceMC"
              placeholder="Tỉnh/Thành phố"
              :disabled="!filters.regionCode || filters.regionCode === '0'"
              @change="getMcDistrict($event)"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.districtCode"
              :options="dataDistrict"
              placeholder="Quận/Huyện"
              :disabled="!filters.provinceCode || filters.provinceCode === '0'"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.ownerType"
              :options="[{ id: 0, text: 'Tất cả' }, ...typeOwner]"
              placeholder="Hình thức sở hữu"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="filters.ownerStatus"
              :options="[{ id: 0, text: 'Tất cả' }, ...statusOwner]"
              placeholder="Trạng thái sở hữu"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.reason"
              :options="Config.getSearch(Config.listReasonAppendix)"
              placeholder="Lý do"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.managerStaffId"
              :settings="settingStaff"
              placeholder="Quản lý của NVCS chính"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.staffId"
              :settings="settingStaff"
              placeholder="Nhân viên chăm sóc chính "
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="filters.contractStaffId"
              :settings="settingStaff"
              placeholder="Nhân viên tạo phụ lục"
            />
          </div>

          <div class="form-group form-group-action">
            <button
              type="button"
              @click="submitForm()"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="clearSearch()"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>

      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="">
              <div class="d-flex flex-row">
                <div class="box-header list_total">
                  <TotalCountCheck
                    :titleTotal="'Tổng số thiết bị:'"
                    :totals="totalCount"
                    :data="[]"
                  ></TotalCountCheck>
                </div>
              </div>
              <b-table
                :busy.sync="loading"
                head-variant="light"
                sticky-header
                hover
                responsive
                :items="dataTable"
                :fields="fieldsTable"
                selectable
                show-empty
                select-mode="single"
                :fixed="true"
                :bordered="true"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
                <template #empty>
                  <div class="text-center text-info my-2">Không có dữ liệu</div>
                </template>
                <template #cell(index)="{ index }">
                  <span class="text-center">
                    {{
                      pagination.page > 1
                        ? index + 1 + pagination.limit * (pagination.page - 1)
                        : index + 1
                    }}
                  </span>
                </template>

                <template #cell(device)="{ item }">
                  <div>
                    <div>
                      <span class="text-secondary">Tên thiết bị:</span>
                      {{ item.nameDevice }}
                    </div>
                    <div>
                      <span class="text-secondary">Serial:</span>
                      {{ item.serialDevice }}
                    </div>
                    <div>
                      <span class="text-secondary">Mobile User:</span>
                      {{ item?.mobileUserStr || '' }}
                    </div>
                  </div>
                </template>

                <template #cell(generalInfo)="{ item }">
                  <div>
                    <div>
                      <span class="text-secondary">MO: </span>
                      <b-link
                        target="_blank"
                        :href="`/customer-support/merchant-owner/${item.merchantOwnerId}`"
                        class="text-primary"
                        >{{ item.ownerName }}</b-link
                      >
                    </div>
                    <div>
                      <span class="text-danger">ĐKKD: </span>
                      <span>{{ item?.businessRegistrationNumber }}</span>
                    </div>
                  </div>
                </template>

                <template #cell(account)="{ item }">
                  <div>
                    <p>
                      <span class="text-secondary">MA:</span>
                      {{ item.accountName }}
                    </p>
                    <p>
                      {{ maskSensitiveInfo(item.email || '') }}
                      <i
                        v-if="item.email"
                        @click="copyToClipboard(item.email)"
                        style="font-size: 16px; margin-left: 5px; color: gray; cursor: pointer"
                        class="bx bxs-copy"
                      ></i>
                    </p>

                    <div v-if="item.storeName">
                      <span class="text-secondary">Cửa hàng:</span>
                      <b-link target="_blank" :href="`/customer-support/store/${item.storeId}`">
                        {{ item.storeName }}</b-link
                      >

                      <p><i class="bx bxs-map"></i>{{ item.address }}</p>
                    </div>
                  </div>
                </template>

                <template #cell(time)="{ item }">
                  <div>
                    <div v-if="item?.firstExportDate">
                      <span class="text-secondary"> Xuất lần đầu: </span>
                      {{ item?.firstExportDate | formatDate('HH:mm DD/MM/YYYY') }}
                    </div>
                    <div v-if="item?.lastRecallDate">
                      <span class="text-secondary"> Thu hồi lần cuối: </span>
                      {{ item?.lastRecallDate | formatDate('HH:mm DD/MM/YYYY') }}
                    </div>
                  </div>
                </template>

                <template #cell(staff)="{ item }">
                  <div>
                    <div v-if="item.createAppendix?.name">
                      <span class="text-secondary">Tạo phụ lục:</span>
                      {{ item.createAppendix?.name }}
                    </div>
                    <div v-if="item.createAppendix?.superiorName">
                      <span class="text-secondary">CS chính:</span>
                      {{ item.createAppendix?.superiorName }}
                    </div>
                  </div>
                </template>

                <template #cell(status)="{ item }">
                  <span>
                    {{ getStatusName(item?.ownerStatus) }}
                  </span>
                </template>

                <template #cell(reason)="{ item }">
                  <div>{{ getReason(item?.reason) }}</div>
                </template>

                <template #cell(ownershipType)="{ item }">
                  <div>{{ getOwnershipType(item?.ownerType) }}</div>
                </template>
                <template #status> </template>

                <template #cell(actions)="{ item }">
                  <div class="text-center">
                    <b-link
                      target="_blank"
                      :href="`/customer-support/device-store/${item.id}`"
                      class="text-primary"
                    >
                      <img
                        src="@/assets/img/circle-three-dots.svg"
                        alt="Circle with Three Dots"
                        style="width: 15px; height: 15px"
                      />
                      Chi tiết</b-link
                    >
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end pagination-bottom">
          <b-form-group class="mb-0" style="padding: 17px">
            <b-form-select
              v-model="pagination.limit"
              :options="pageOptions"
              @change="onItemsPerPageChange"
            ></b-form-select>
          </b-form-group>
          <b-pagination
            v-model="pagination.page"
            @change="onChangePage"
            :total-rows="pagination.total"
            :per-page="pagination.limit"
            class="mr-2 fl-right"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { List } from '@/services/customer-support/device-store'
  import { SearchStaff } from '@/services/customer-support/staff'
  import TotalCountCheck from '@/components/cskh/Counts.vue'
  import { CommonService } from '@/services/common.service'
  import { showMess } from '@/config/utils'
  import DateRangePicker from 'vue2-daterange-picker'
  import { List as ListMo } from '@/services/customer-support/merchant-owner'
  import { Search as ListMa } from '@/services/customer-support/account'
  import { List as ListStore } from '@/services/customer-support/store'
  import { level3LocationDetails } from '@/config/manhthdConfigs'
  import { StaffService } from '@/services/staff.service'

  const fieldsTable = [
    {
      key: 'index',
      label: 'STT',
      class: 'text-center',
      thStyle: 'min-width: 50px',
      thClass: 'text-center',
    },
    {
      key: 'device',
      label: 'Thiết bị',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'generalInfo',
      label: 'Thông tin chung',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'account',
      label: 'Tài khoản/ Cửa hàng',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'time',
      label: 'Thời gian',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'staff',
      label: 'Nhân viên',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'status',
      label: 'Trạng thái sở hữu',
      thStyle: 'min-width: 120px',
      thClass: 'text-center',
    },
    {
      key: 'reason',
      label: 'Lý do',
      thStyle: 'min-width: 100px',
    },
    {
      key: 'ownershipType',
      label: 'Hình thức sở hữu',
      thStyle: 'min-width: 120px',
      thClass: 'text-center',
    },
    {
      key: 'actions',
      label: 'Thao tác',
      class: 'text-center',
      thStyle: 'min-width: 80px',
    },
  ]

  const typeMapping = {
    EMPLOYEE: 'Nhân viên',
    MERCHANT: 'Merchant',
  }

  export default {
    components: { TotalCountCheck, DateRangePicker },
    data() {
      return {
        pageOptions: [
          { value: 20, text: '20/trang' },
          { value: 50, text: '50/trang' },
          { value: 100, text: '100/trang' },
          { value: 200, text: '200/trang' },
        ],
        Config,
        fieldsTable,
        typeMapping,
        showLoading: false,
        totalCount: 0,
        totals: [],

        statusOwner: [
          { id: 'NEW', text: 'Mới' },
          { id: 'TRANSFERRED', text: 'Chuyển nhượng' },
          { id: 'HANDED_OVER', text: 'Bàn giao' },
          { id: 'LIQUIDATED', text: 'Thanh lý' },
          { id: 'RECALLED', text: 'Thu hồi' },
        ],

        typeOwner: [
          { id: 'PURCHASE', text: 'Mua' },
          { id: 'RENT', text: 'Thuê' },
          { id: 'LEND', text: 'Mượn' },
          { id: 'CASHBACK', text: 'Cashback' },
        ],

        dataDistrict: [],
        dataProvince: [],
        dataConfigRegionMC: [],
        dataProvinceMC: [],

        filters: {},
        localeData: Config.localeData,
        loading: false,
        dataStaff: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        settingStaff: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              if (this.tLoadAccount) {
                clearTimeout(this.tLoadAccount)
              }
              this.tLoadAccount = setTimeout(() => {
                SearchStaff({
                  keyWord: txtSearch,
                  limit: 20,
                  page: 1,
                })
                  .then(res => {
                    success({
                      results:
                        res.data?.map(item => ({
                          id: item?.id,
                          text: item?.name || item?.userName || item?.email,
                        })) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        moOptions: [],
        maOptions: [],
        storeOptions: [],

        tLoadMo: undefined,
        moSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              if (this.tLoadMo) {
                clearTimeout(this.tLoadMo)
              }
              this.tLoadMo = setTimeout(() => {
                ListMo({
                  showFields: ['id', 'ownerName', 'email'],
                  limit: 10,
                  page: 1,
                  keyWord: txtSearch,
                  sort: {
                    direction: 'ASC',
                    properties: ['ownerName'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data.list?.map(item => {
                          return {
                            id: item.id,
                            text: item.ownerName || item.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        tLoadMa: undefined,
        maSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              const querys = [`{textSearch} LIKE '''${txtSearch}'''`]
              this.filters.moId && querys.push(`{merchantOwnerId} == '''${this.filters.moId}'''`)

              if (this.tLoadMa) {
                clearTimeout(this.tLoadMa)
              }
              this.tLoadMa = setTimeout(() => {
                ListMa({
                  showFields: ['id', 'accountName', 'email'],
                  limit: 10,
                  page: 1,
                  queryString: querys.join(' AND '),
                  sort: {
                    direction: 'ASC',
                    properties: ['accountName'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data.listData?.map(item => {
                          return {
                            id: item.id,
                            text: item.accountName || item.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        tLoadStore: undefined,
        storeSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              const querys = [
                `({textSearch} LIKE '''${txtSearch}''' OR {address} LIKE '''${txtSearch}''')`,
              ]
              this.filters.moId && querys.push(`{merchantOwnerId} == '''${this.filters.moId}'''`)
              this.filters.maId && querys.push(`{mcAccountId} == '''${this.filters.maId}'''`)

              if (this.tLoadStore) {
                clearTimeout(this.tLoadStore)
              }
              this.tLoadMa = setTimeout(() => {
                ListStore({
                  showFields: ['id', 'storeName', 'email'],
                  limit: 10,
                  page: 1,
                  queryString: querys.join(' AND '),
                  sort: {
                    direction: 'ASC',
                    properties: ['storeName'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data.listData?.map(item => {
                          return {
                            id: item.id,
                            text: item.storeName || item.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        pagination: {
          sortField: 'created_date',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        },
        dataTable: [],
      }
    },
    async created() {
      const queries = this.$router.currentRoute.query
      if (queries.fullTextSearch) {
        this.filters.fullTextSearch = queries.fullTextSearch
      }
      if (queries.storeId && queries.storeName) {
        this.storeOptions = [
          {
            id: queries.storeId,
            text: queries.storeName,
          },
        ]
        this.filters.storeId = queries.storeId
      }

      if (queries.maId && queries.maName) {
        this.maOptions = [
          {
            id: queries.maId,
            text: queries.maName,
          },
        ]
        this.filters.maId = queries.maId
      }

      await this.configSystem()
      await this.getMcRegions()
      await this.buildQuery()
    },

    computed: {
      getStatusName() {
        return status => {
          if (!status) return ''
          const mapStatus = this.statusOwner.reduce((acc, cur) => {
            acc[cur.id] = cur.text
            return acc
          }, {})
          return mapStatus[status] || status
        }
      },
      // formatDateTime() {
      //   return (timestamp) => {
      //     const date = new Date(timestamp)
      //     const day = date.getDate().toString().padStart(2, '0')
      //     const month = (date.getMonth() + 1).toString().padStart(2, '0')
      //     const year = date.getFullYear()
      //     const hours = date.getHours().toString().padStart(2, '0')
      //     const minutes = date.getMinutes().toString().padStart(2, '0')

      //     return `${hours}:${minutes}, ${day}/${month}/${year}`
      //   }
      // },
      getOwnershipType() {
        return type => {
          if (!type) return ''

          const map = this.typeOwner.reduce((acc, cur) => {
            if (cur && cur.id) {
              acc[cur.id] = cur
            }
            return acc
          }, {})

          return map[type]?.text || type || ''
        }
      },
      getReason() {
        return reason => {
          if (!reason) return ''
          const mapReason = Config.listReasonAppendix.reduce((acc, cur) => {
            if (cur && cur.id) {
              acc[cur.id] = cur.text
            }
            return acc
          }, {})
          return mapReason[reason] || reason
        }
      },
    },

    methods: {
      copyToClipboard(text) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            showMess(
              this,
              'Success',
              'Sao chép thành công',
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          })
          .catch(err => {
            console.error('Lỗi khi sao chép: ', err)
            showMess(
              this,
              'Error',
              'Lỗi khi sao chép: ' + err,
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          })
      },
      maskSensitiveInfo(input) {
        if (input.includes('@')) {
          return input.replace(/(.{2}).+(@.+)/, '$1****$2')
        } else if (/^(\d{10})$/.test(input) || /(\d{2,3})\d{4}(\d{3,4})/.test(input)) {
          return input.replace(/(\d{2,3})\d{4}(\d{3,4})/, '$1****$2')
        } else {
          return input.replace(/(.{3}).+(.{3})/, '$1****$2')
        }
      },
      // lấy vùng mc
      async getMcRegions() {
        const data = await StaffService.getListRegions()
        if (data.data.length > 0) {
          this.dataConfigRegionMC = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
              code: e.code,
            }
          })
          this.dataConfigRegionMC.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp mc
      async queryMcProvince(e) {
        try {
          this.filters.provinceCode = ''
          this.filters.districtCode = ''
          this.dataDistrict = []
          this.dataProvinceMC = []
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvinceMC = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.dataProvinceMC.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {}
      },
      // lấy quận mc
      async getMcDistrict(event) {
        this.dataDistrict = level3LocationDetails
          .filter(item => item.code.includes(event))
          .sort((a, b) => a.code.localeCompare(b.code))
          .map(e => {
            return {
              id: e.code,
              text: e.name,
            }
          })
        this.dataDistrict.unshift({ id: '0', text: 'Tất cả' })
      },
      transformDate() {
        this.filters.createDateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.filters.createDateTo = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      onChangeMo() {
        this.filters.maId = ''
        this.filters.storeId = ''
      },

      onChangeMa() {
        this.filters.storeId = ''
      },

      async clearSearch() {
        this.filters = {
          fullTextSearch: '',
          moId: '',
          maId: '',
          maEmail: '',
          createDateFrom: null,
          createDateTo: null,
          appendixCreator: '',
          status: '',
          reason: '',
          regionCode: '',
          storeId: '', // Thêm
          ownerType: '', // Thêm
          ownerStatus: '', // Thêm
          provinceCode: '', // Thêm
          districtCode: '', // Thêm
          managerStaffId: '', // Thêm
          staffId: '', // Thêm
          contractStaffId: '', // Thêm
          firstExportDate: null, // Thêm
          lastExportDate: null, // Thêm
        }

        this.pagination = {
          // sortField: 'created_date',
          // sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }

        await this.buildQuery()
      },
      async buildQuery() {
        const conditionsMap = {}
        const listKeyParams = [
          'fullTextSearch', // Tên mã/ địa chỉ thiết bị
          'moId', // MO
          'maId', // Ma
          'maEmail', // MA
          'storeId', // Cửa hàng
          'ownerType', // Trạng thái sở hữu
          'reason', // Lý do
          'ownerStatus', // Hình thức sở hữu
          'regionCode', // Vùng cửa hàng
          'provinceCode', // Tỉnh/thành phố
          'districtCode', // Quận/huyện
          'managerStaffId', // Quản lý của nhân viên chăm sóc chính
          'staffId', // Nhân viên chăm sóc chính
          'contractStaffId', // Nhân viên tạo phụ lục
          // 'firstExportDate' // Thời gian xuất lần đầu
        ]
        listKeyParams.forEach(key => {
          if (this.filters[key] && this.filters[key] !== '0' && this.filters[key] !== 0) {
            conditionsMap[key] = this.filters[key]
          }
        })

        if (this.dateRange?.startDate && this.dateRange?.endDate) {
          this.filters.firstExportDate = moment(this.dateRange.startDate).startOf('day').valueOf()
          this.filters.lastExportDate = moment(this.dateRange.endDate).endOf('day').valueOf()
        }

        conditionsMap.regionCode = this.dataConfigRegionMC.find(
          e => e.id === this.filters.regionCode
        )?.code

        conditionsMap.firstExportDate = this.filters.firstExportDate
        conditionsMap.lastExportDate = this.filters.lastExportDate

        await this.loadData(conditionsMap)
      },

      async loadData(conditionsMap = {}) {
        try {
          this.loading = true
          const searchQuery = {
            countStatus: true,
            limit: this.pagination.limit,
            page: this.pagination.page,
            ...conditionsMap,
          }
          const res = await List(searchQuery)
          if (res.code === 1000) {
            const { data, count } = res.data
            this.dataTable = data || []
            this.pagination.total = count || 0
            this.totalCount = count ?? 0
          }
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loading = false
        }
      },

      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.buildQuery()
      },
      onItemsPerPageChange() {
        this.pagination.page = 1
        this.buildQuery()
      },

      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
            }
          })
          .catch(error => console.error(error))
      },
      async submitForm() {
        this.pagination.page = 1
        await this.buildQuery()
      },
    },
  }
</script>

<style lang="scss" scoped></style>
